import {
    abroadTransfersSlide,
    indivCreditHolidaysSlide,
    pensionSlide,
} from '@/core/models/common/OfferSliderSlides/OtherSlidesModel';
import {
    newComfortDepositSlideHypotises,
    greenDepositSlide,
    // newComfortDepositSlide,
    premiumDepositSlide,
    m4DepositSlide,
    mortgageDepositSlide,
    exclusiveDepositSlide,
    cumulativeDepositSlide,
    seasonDepositSlide,
} from '@/core/models/common/OfferSliderSlides/ForIndividuals/DepositsSlidesModel';
import {
    fanCardSlide,
    advancedCardSlide,
    mirSupremeCardSlide,
    childrenCardSlide,
} from '@/core/models/common/OfferSliderSlides/ForIndividuals/CardSlidesModel';
import {
    potrebCreditSlide,
    carLoanSlide,
    firstLoanCredit,
} from '@/core/models/common/OfferSliderSlides/ForIndividuals/CreditSlidesModel';
import {
    mortgageChildSlide,
    mortgageVillageSlide,
    itMortgageSlide,
    mortgagesSecondarySlide,
    mosPrimeSlide,
    firstLoanMortgage,
    largeFamilyMortgageSlide,
} from '@/core/models/common/OfferSliderSlides/ForIndividuals/MortgageSlidesModel';

const popular = [
    premiumDepositSlide,
    pensionSlide,
    abroadTransfersSlide,
    greenDepositSlide,
    advancedCardSlide,
    mirSupremeCardSlide,
];

const mortgage = [
    largeFamilyMortgageSlide,
    firstLoanMortgage,
    mosPrimeSlide,
    itMortgageSlide,
    mortgageVillageSlide,
    mortgagesSecondarySlide,
    mortgageChildSlide,
];

const credit = [
    firstLoanCredit,
    potrebCreditSlide,
    carLoanSlide,
    indivCreditHolidaysSlide,
];

const deposit = [
    newComfortDepositSlideHypotises,
    exclusiveDepositSlide,
    premiumDepositSlide,
    // newComfortDepositSlide,
    greenDepositSlide,
    m4DepositSlide,
    mortgageDepositSlide,
    cumulativeDepositSlide,
    seasonDepositSlide,
];

const promo = [fanCardSlide];

const children = [childrenCardSlide];

const pensioner = [pensionSlide];

const tabsData = [
    {
        label: 'Популярные',
        slotName: 'popular',
    },
    {
        label: 'Вклад',
        slotName: 'deposit',
    },
    {
        label: 'ПРОМО',
        slotName: 'promo',
    },
    {
        label: 'Родителям и детям',
        slotName: 'children',
    },
    {
        label: 'Пенсионерам',
        slotName: 'pensioner',
    },
];

export {
    popular,
    mortgage,
    credit,
    deposit,
    promo,
    tabsData,
    children,
    pensioner,
};
